import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const logInAction = {
    ...operations,
    ...selectors,
};

export {
    logInAction,
};
export default {
    [namespace]: reducer,
};
